import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-error-page',
  standalone: true,
  imports: [
    RouterLink,
    CommonModule,
    TranslateModule
  ],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss'
})
export class ErrorPageComponent {
  private _route = inject(ActivatedRoute)
  
  error: string | null = null;
  errorDescription: string | null = null;

  ngOnInit(): void {
    this._route.queryParams.subscribe(params => {
      this.error = params['error'];
      this.errorDescription = params['error_description'];
    });
  }
}
